import Vue from 'vue';
import Router from 'vue-router';
import { BasicLayout, UserLayout } from '@/layouts';
import preferRouter from './modules/prefer';
import brandRouter from './modules/brand';
import seriesRouter from './modules/series';
import goodsRouter from './modules/goods';
import carouselRouter from './modules/carousel';
import storesRouter from './modules/stores';
import exchangeRouter from './modules/exchange';
import auditRouter from './modules/audit';
import cardTicketRouter from './modules/cardticket';
import buyRecordRouter from './modules/buyrecord';
import templateRouter from './modules/template';

// NavigationDuplicated 静音
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

// 静态路由
export const constantRoutes = [
  {
    path: '/user',
    name: 'User',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/user/Login'),
      },
    ],
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    redirect: '/prefer',
    meta: {
      title: '',
    },
    children: [
      preferRouter,
      brandRouter,
      seriesRouter,
      goodsRouter,
      carouselRouter,
      storesRouter,
      exchangeRouter,
      auditRouter,
      cardTicketRouter,
      buyRecordRouter,
      templateRouter,
    ],
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: constantRoutes,
});

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
